module.exports = __webpack_public_path__ + "static/media/fit.bb4aba76.pdf";